if (!customElements.get('dna-report-carousel')) {
  class DnaReportCarousel extends HTMLElement {
    constructor() {
      super();
      this.slides = [].slice.call(this.querySelectorAll('[data-dna-slide]'));
      this.ring = this.querySelector('[data-hex-ring]');
      this.logo = this.querySelector('[data-hex-logo]');
      this.hexNodes = [].slice.call(this.querySelectorAll('[data-hex-index]'));
      this.labels = [].slice.call(this.querySelectorAll('[data-hex-label]'));
      this.currentRotation = 0;
      this.logoRotation = 0;
      this.activeIndex = 0;
      this._itemToHex = {};
      this._lastActiveItem = null;
    }

    connectedCallback() {
      var self = this;
      this._sectionInView = false;

      this.hexNodes.forEach(function (node) {
        self._itemToHex[node.dataset.hexItem] = parseInt(
          node.dataset.hexIndex,
          10
        );
      });

      this.hexNodes.forEach(function (node) {
        var idx = parseInt(node.dataset.hexIndex, 10);
        node.addEventListener('click', function () {
          self.selectNode(idx);
        });
      });

      this.slides.forEach(function (slide) {
        slide.addEventListener('click', function () {
          var offset = parseInt(slide.getAttribute('data-dna-offset'), 10);
          if (offset === 0 || isNaN(offset)) return;
          var item = slide.getAttribute('data-dna-item');
          var hexIdx = self._itemToHex[item];
          if (hexIdx !== undefined) {
            self.selectNode(hexIdx);
          }
        });
      });

      this.slides.forEach(function (slide) {
        var video = slide.querySelector('video');
        if (!video) return;
        video.addEventListener('ended', function () {
          video.pause();
        });
      });

      var prevBtn = this.querySelector('[data-dna-prev]');
      var nextBtn = this.querySelector('[data-dna-next]');
      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          var prev = (self.activeIndex - 1 + self.hexNodes.length) % self.hexNodes.length;
          self.selectNode(prev);
        });
      }
      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          var next = (self.activeIndex + 1) % self.hexNodes.length;
          self.selectNode(next);
        });
      }

      this.updateImage();

      this._io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            self._sectionInView = entry.isIntersecting;
            self._syncVideos(false);
          });
        },
        { threshold: 0.15 }
      );
      this._io.observe(this);
    }

    disconnectedCallback() {
      if (this._io) {
        this._io.disconnect();
        this._io = null;
      }
    }

    selectNode(index) {
      if (index === this.activeIndex) {
        this._restartActiveVideo();
        return;
      }

      var diff = index - this.activeIndex;
      if (diff > 3) diff -= 6;
      if (diff < -3) diff += 6;

      this.currentRotation -= diff * 60;
      this.logoRotation += diff * 60;
      this.activeIndex = index;

      this.ring.style.transform = 'rotate(' + this.currentRotation + 'deg)';
      this.logo.style.transform =
        'translate(-50%, -50%) rotate(' + this.logoRotation + 'deg)';
      this.updateActiveStates();
      this.updateImage();
    }

    updateActiveStates() {
      var counterAngle = -this.currentRotation;
      for (var i = 0; i < this.hexNodes.length; i++) {
        var isActive = i === this.activeIndex;
        this.hexNodes[i].classList.toggle('is-active', isActive);
        this.labels[i].style.transform = 'rotate(' + counterAngle + 'deg)';
      }
    }

    updateImage() {
      var activeItem = this.hexNodes[this.activeIndex].dataset.hexItem;
      var activeSlideChanged = this._lastActiveItem !== activeItem;
      this._lastActiveItem = activeItem;

      var activeSlideIdx = -1;

      for (var i = 0; i < this.slides.length; i++) {
        if (this.slides[i].getAttribute('data-dna-item') === activeItem) {
          activeSlideIdx = i;
          break;
        }
      }

      for (var i = 0; i < this.slides.length; i++) {
        var offset = i - activeSlideIdx;
        this.slides[i].setAttribute('data-dna-offset', String(offset));
        this.slides[i].classList.toggle('is-active', offset === 0);
      }

      this._syncVideos(activeSlideChanged);
    }

    _restartActiveVideo() {
      var activeItem = this.hexNodes[this.activeIndex].dataset.hexItem;
      for (var i = 0; i < this.slides.length; i++) {
        if (this.slides[i].getAttribute('data-dna-item') !== activeItem) continue;
        var video = this.slides[i].querySelector('video');
        if (!video) return;
        video.currentTime = 0;
        if (this._sectionInView) {
          video.play().catch(function () {});
        }
        return;
      }
    }

    _syncVideos(activeSlideChanged) {
      var inView = this._sectionInView;
      for (var i = 0; i < this.slides.length; i++) {
        var video = this.slides[i].querySelector('video');
        if (!video) continue;
        var isActive =
          this.slides[i].getAttribute('data-dna-offset') === '0';

        if (!isActive) {
          video.pause();
          continue;
        }

        if (activeSlideChanged) {
          video.currentTime = 0;
        }

        if (!inView) {
          video.pause();
          continue;
        }

        if (activeSlideChanged) {
          video.play().catch(function () {});
        } else if (!video.ended && video.paused) {
          video.play().catch(function () {});
        }
      }
    }
  }

  customElements.define('dna-report-carousel', DnaReportCarousel);
}
